<script>
    export default {
        props: {
            param: {
                type: String,
                default: 'q'
            },
            url: {
                type: String,
                default: '/zoeken'
            },
            placeholder: {
                type: String,
                default: 'Zoek...'
            },
            heading: {
                type: String,
                default: 'Zoeken'
            },
        },
        methods: {
            close() {
                this.$store.commit('closeModal');
            },
        },
        mounted() {
            this.$refs.input.focus();
        },
    };
</script>

<template>
    <header class="modal-card-head">
        <p class="modal-card-title">{{ heading }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
    </header>
    <section class="modal-card-body">
        <form method="GET" :action="url">
            <div class="field has-addons navbar-search">
                <div class="control is-flex-grow-1">
                    <input :name="param" class="input" type="search" :placeholder="placeholder" ref="input">
                </div>
                <div class="control">
                    <button type="submit" class="button is-primary" aria-label="zoeken">
                        <span class="icon">
                            <i class="fa-solid fa-search"></i>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </section>
    <footer class="modal-card-foot is-justify-content-end">
        <button class="button is-primary is-outlined" @click="close">Annuleren</button>
    </footer>
</template>
